export default {
  setSelectedProduct: ({ productTable }, payload) => {
    productTable.selectedProduct = payload;
  },
  setProductTableMode: ({ productTable }, payload) => {
    productTable.mode = payload;
    let sortBy = 'reviewNumber';
    if (payload === 'questions') {
      sortBy = 'questionsNumber';
    } else if (payload === 'google-merchant' || payload === 'bazaarvoice') {
      sortBy = 'linkedProducts';
    }
    productTable.pagination.sortBy = [sortBy];
    productTable.pagination.descending = [true];
  },
  setProductTableLoading: ({ productTable }, payload) => {
    productTable.loading = payload;
  },
  setProductSearch: ({ productTable }, payload) => {
    productTable.pagination.search = payload;
  },
  loadProductTableIncr: ({ productTable }, payload) => {
    productTable.pagination.totalItems = payload.recordsTotal;
    if (productTable.pagination.page > 1) {
      // append products to existing products if "Load more" is clicked
      for (const item of payload.data) {
        if (!productTable.data.find(el => el.id == item.id)) {
          productTable.data.push(item);
        }
      }
    } else {
      productTable.data = payload.data;
    }
    productTable.loading = false;
  },
  loadProductTableFlat: ({ productTable }, payload) => {
    productTable.pagination.totalItems = payload.recordsTotal;
    productTable.data = payload.data;
    productTable.loading = false;
  },
  setProductTablePagination({ productTable }, payload) {
    productTable.pagination.descending = payload.descending;
    productTable.pagination.page = payload.page;
    productTable.pagination.rowsPerPage = payload.rowsPerPage;
    productTable.pagination.sortBy = payload.sortBy;
    productTable.pagination.totalItems = payload.totalItems;
    productTable.pagination.search = payload.search;
  },
  searchProductsSuccess: (state, payload) => {
    state.productSearch.items = payload.data;
    state.productSearch.loading = false;
  },
  setProductSearchInput: (state, payload) => {
    state.productSearch.items = payload.items;
    state.productSearch.loading = payload.loading;
    state.productSearch.query = payload.query;
  },
};
